import { isToday, isYesterday, format } from 'date-fns';
import { useIntl } from 'react-intl';
import { is240DaysOld } from '../hooks/firebase/common';

export const LastMessageTime = (props: { timestamp?: Date }) => {
  const intl = useIntl();
  const { timestamp } = props;

  if (timestamp && is240DaysOld(timestamp)) {
    return null;
  }

  let timeText: string;
  if (!timestamp) {
    timeText = '';
  } else if (isToday(timestamp)) {
    timeText = format(timestamp, 'HH:mm a');
  } else if (isYesterday(timestamp)) {
    timeText = intl.formatMessage({ id: 'common.yesterday' });
  } else {
    timeText = format(timestamp, 'MM/dd/yy');
  }
  return <>{timeText}</>;
};
